"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const close_svg_1 = __importDefault(require("@components/icons/close.svg"));
const ExerciseLink = styled_components_1.default.a.attrs({
    href: '#target-charts'
}) `
  font-family: Inter, sans-serif;
  font-size: 12px;
  cursor: pointer;
  padding: 7px 15px;
  border-bottom: 1px solid #ccc;
  text-decoration: none;
  display: block;
  color: #413d3d;
  &:hover {
    color: #7B4EF8;
  }
`;
const CategoryHalfDonutsPopup = ({ ev, data, closePopup, setTargetExercise }) => {
    var _a;
    const handleLinkClick = (exerciseSlug) => () => {
        closePopup();
        setTargetExercise(exerciseSlug);
    };
    const selectedData = data[ev.dataPointIndex];
    const tooCloseRight = document.body.clientWidth - ev.clientX < 200;
    const leftCorrective = tooCloseRight ? 260 : 0;
    const pointerPositionStyles = tooCloseRight ? {
        top: 23,
        right: -8
    } : {
        top: 10,
        left: -8
    };
    return (react_1.default.createElement("span", { className: "donuts-popup", style: {
            background: '#fff',
            boxShadow: '#888 2px 2px 15px',
            borderRadius: '6px',
            position: 'absolute',
            padding: '10px 10px 10px 17px',
            left: ev.clientX + 15 - leftCorrective,
            top: ev.clientY - 65 + document.body.scrollTop,
            zIndex: 9999
        } },
        react_1.default.createElement("span", { style: { float: 'right', cursor: 'pointer', paddingLeft: '5px' }, onClick: closePopup },
            react_1.default.createElement(close_svg_1.default, null)),
        react_1.default.createElement("span", { className: "donuts-exercise-list", style: {
                overflow: 'auto',
                width: '200px',
                maxHeight: '150px',
                display: 'block',
                paddingRight: '10px'
            } }, (_a = selectedData === null || selectedData === void 0 ? void 0 : selectedData.exercise_names) === null || _a === void 0 ? void 0 : _a.map((exerciseName, index) => react_1.default.createElement(ExerciseLink, { key: selectedData.exercise_slugs[index], onClick: handleLinkClick(selectedData.exercise_slugs[index]) }, exerciseName))),
        react_1.default.createElement("div", { style: Object.assign({ width: '20px', height: '20px', position: 'absolute', background: '#fff', borderRadius: '4px', transform: 'rotate(61deg) skew(-1deg, -25deg)' }, pointerPositionStyles) })));
};
exports.default = CategoryHalfDonutsPopup;
